import { FC } from 'react'

import { Box, SearchField, Text } from '@factorialco/deprecated-design-system'

import SingleChoice from 'modules/core/components/Filter/filters/SingleChoice'
import Loading from 'modules/core/components/Loading'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import useModulesList from 'modules/marketplace_modules/hooks/useModulesList'

import ModuleCard from './ModuleCard'
import { useModuleListSearch } from './ModuleListSearchProvider'
import PopularModules from './PopularModules'
import * as styles from './index.vanilla.css'

const List: FC = () => {
  const {
    search,
    availableFilter,
    setAvailableFilter,
    availabilityFilterOptions,
    categoryFilter,
    setCategoryFilter,
  } = useModuleListSearch()
  const { loading, popularModules, filteredModules, getCategoriesNames } = useModulesList()

  useEffect(() => {
    search.debouncedSearch
  }, [search.debouncedSearch])

  if (loading) return <Loading />

  const modulesFiltered = filteredModules(
    availableFilter,
    search.debouncedSearch.toLocaleLowerCase(),
    categoryFilter
  )

  return (
    <Box width="full" gap="s32">
      <Box justifyContent="spaceBetween" flexDirection="row">
        <Box>
          <SearchField
            onSearch={search.onSearch}
            search={search.search}
            placeholder={i18n.t('common.search')}
          />
        </Box>
        <Box flexDirection="row" justifyContent="spaceBetween" gap="s8">
          <SingleChoice
            label={i18n.t('marketplace.modules.filters.category.label')}
            value={categoryFilter}
            onValueChange={(value) => setCategoryFilter(value || '')}
            options={getCategoriesNames()}
          />
          <SingleChoice
            label={i18n.t('marketplace.modules.filters.availability.label')}
            value={availableFilter}
            onValueChange={(value) => setAvailableFilter(value)}
            options={availabilityFilterOptions}
          />
        </Box>
      </Box>
      <Box className={styles.wrapper}>
        {modulesFiltered.length ? (
          <Box flexDirection="row" paddingBottom="s64" width="full">
            <Box flexDirection="column" gap="s24" justifyContent="flexStart" width="full">
              <ModuleCard modules={modulesFiltered} />
            </Box>
          </Box>
        ) : (
          <Box alignItems="center">
            <Text.Normal>{i18n.t('marketplace.modules.filters.no_results')}</Text.Normal>
          </Box>
        )}
        <PopularModules modules={popularModules()} />
      </Box>
    </Box>
  )
}

export default List
